import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
import { useSegmentation } from '@printdeal/segmentation/react';
import { selectors as authSelectors } from '../../../store/slices/authSlice';
import ConversationLoop from './ConversationLoop';
import { dispatchDataLayerEventOnConversationAppLinkClick } from '../CustomerServiceNavigation/helpers/reseller-customer-care-navigation-events';

interface ConversationLoopLinkProps {
  linkIcon?: 'checklist' | 'chevron-right';
  handleCustomerCareLinkMouseLeave?: () => void;
  handleMobileCustomerServiceLinkClickClose?: () => void;
}

const ConversationLoopLink = ({ linkIcon = 'checklist', handleCustomerCareLinkMouseLeave, handleMobileCustomerServiceLinkClickClose }: ConversationLoopLinkProps) => {
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const { data: segmentationData } = useSegmentation();
  const { isReseller } = segmentationData ?? { isReseller: false };

  if (!isLoggedIn || !isReseller) return null;

  const handleConversationAppLinkClick = () => {
    setFeedbackModalOpen(true);
    dispatchDataLayerEventOnConversationAppLinkClick();
  };

  return (
    <>
      <LinkAsButton
        iconBefore={linkIcon}
        variant="secondary"
        onClick={handleConversationAppLinkClick}
      >
        <FormattedMessage id="general.widget.contact.feedback.link" defaultMessage="Share feedback" />
      </LinkAsButton>
      {feedbackModalOpen
        && (
        <ConversationLoop
          setFeedbackModalOpen={setFeedbackModalOpen}
          handleCustomerCareLinkMouseLeave={handleCustomerCareLinkMouseLeave}
          handleMobileCustomerServiceLinkClickClose={handleMobileCustomerServiceLinkClickClose}
        />
        )}
    </>
  );
};

export default ConversationLoopLink;
